import { Component } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'cs-quote-banner',
  templateUrl: './quote-banner.component.html',
  styleUrls: ['./quote-banner.component.scss']
})
export class QuoteBannerComponent {
  visible = true;
  modalOpen = false;
  iframeLoading = false;
  iframeUrl: SafeResourceUrl;

  private readonly formUrl = 'https://culturestudio.net/catalog-form-submit/';

  constructor(private sanitizer: DomSanitizer) {}

  openModal(): void {
    this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.formUrl);
    this.iframeLoading = true;
    this.modalOpen = true;
  }

  closeModal(): void {
    this.modalOpen = false;
  }

  dismiss(event: Event): void {
    event.stopPropagation();
    this.visible = false;
  }
}
